import React, { useEffect, useState } from 'react'
import {
  BlockingLoader,
  Button,
  Container,
  CheckboxGroup,
  Icon,
  Link,
  Tabs,
  TextBody,
  TextCaption,
  TextTitle,
  ToastContext,
  Tools
} from '@pmi/pmi-iqos-ds-react'
import {
  CommonTranslations,
  htmlTranslation,
  parseTranslations,
  PublishedComponent,
  extractErrorMessage,
  analytics,
  cookie
} from '@pmi/pmi-iqos-shared-react'
import { getInitialPropsMock, mapPrizeToProduct } from '@iqosphere-common/utils'
import { api } from '@iqosphere-common/services'
import { LoyaltyProductList } from '@iqosphere-common/components'
import LotteryProductListTranslations from './lottery-product-list.json'

const LotteryProductListComponent = ({
  translations,
  productDataList,
  filters,
  termsUrl,
  bauPath,
  reqProps
}) => {
  const sections = {
    exchange: 'exchange',
    lottery: 'lottery'
  }
  const tabItems = [
    {
      label: translations.tk_tabsAll,
      sections: [sections.lottery, sections.exchange]
    },
    {
      label: translations.tk_tabsLottery,
      sections: [sections.lottery]
    },
    {
      label: translations.tk_tabsExchange,
      sections: [sections.exchange]
    }
  ]

  const [productLists, setProductLists] = useState({})
  const [loading, setLoading] = useState(false)
  const [selectedTabItemIndex, setSelectedTabItemIndex] = useState(0)
  const [filterSelection, setFilterSelection] = useState(
    filters && filters.map(f => false)
  )
  const [showFilters, setShowFilters] = useState(false)

  useEffect(() => {
    setLoading(true)
    const productMap = {
      [sections.lottery]: {
        title: tabItems[1].label,
        products: []
      },
      [sections.exchange]: {
        title: tabItems[2].label,
        products: []
      }
    }
    const mappedProductDataList = productDataList.map(productData => ({
      ...mapPrizeToProduct(productData)
    }))
    mappedProductDataList.forEach(({ product }) => {
      const section = product && product.loyalty && product.loyalty.section
      section &&
        productMap[section] &&
        productMap[section].products.push(product)
    })
    setProductLists({ ...productMap })
    setLoading(false)
  }, [])
  /*
  const handleOptionChange = (section, product, selectedOptionIndex) => {
    const index = productLists[section].products
      .map(p => p.id)
      .indexOf(product.id)
    if (index >= 0) {
      const updatedProducts = [...productLists[section].products]
      updatedProducts[index].selectedOptionIndex = selectedOptionIndex
      setProductLists({
        ...productLists,
        [section]: {
          title: productLists[section].title,
          products: [...updatedProducts]
        }
      })
    }
  }
*/
  const handleClickTab = index => {
    setSelectedTabItemIndex(index)
  }

  const toggleFilterHandler = (filter, index) => {
    analytics.clickEvent({
      eventCategory: 'Lottery',
      eventLabel: `Apply Filter - [${filter.min} ~ ${filter.max}]`,
      user_id: cookie.getSpiceId() || ''
    })
    const newFilterSelection = [...filterSelection]
    newFilterSelection[index] = !newFilterSelection[index]
    setFilterSelection(newFilterSelection)
  }

  const cleanFilterHandler = () => {
    setFilterSelection([])
  }

  const getFilteredProducts = products => {
    const activeFilters = (filters || []).filter(
      (filter, index) => filterSelection[index] === true
    )
    return activeFilters.length === 0
      ? products
      : products.filter(product => {
          const qoins = product.options[product.selectedOptionIndex].qoins
          return activeFilters.reduce(
            (acc, activeFilter) =>
              acc || (qoins >= activeFilter.min && qoins <= activeFilter.max),
            false
          )
        })
  }

  const getFilterLabel = filter => {
    return '' + filter.min + ' - ' + filter.max
  }

  const FiltersTitle = () => {
    return <TextCaption>{translations.tk_qoins}</TextCaption>
  }

  const toggleShowFilters = () => {
    setShowFilters(!showFilters)
  }

  const Filters = () => {
    return (
      <>
        <CheckboxGroup
          name=""
          label=""
          items={filters}
          isItemSelected={(filter, index) => filterSelection[index]}
          getItemLabel={filter => getFilterLabel(filter)}
          onChangeHandler={toggleFilterHandler}
          checkDesign={CheckboxGroup.checkDesigns.button}
        />
        {filterSelection.includes(true) && (
          <Container py="8">
            <Button
              icon={Icon.images.cancel}
              iconPosition={Button.iconPositions.left}
              text={translations.tk_removeFilter}
              variant={Button.variants.tertiary}
              onClickHandler={cleanFilterHandler}
            />
          </Container>
        )}
      </>
    )
  }

  const filteredProductsBySection = {}
  tabItems[selectedTabItemIndex].sections.forEach(section => {
    const productList = productLists[section]
    filteredProductsBySection[section] = {
      title: productList && productLists[section].title,
      products: getFilteredProducts(
        productList ? productLists[section].products : []
      )
    }
  })
  return (
    <>
      <BlockingLoader loading={loading} />
      <Container fullWidth display={Container.displays.flex}>
        {Tools.isDesktop() ? (
          <Container width="1/4" pr="8">
            <Container pb="5" divider={Container.dividers.bottom}>
              <TextBody {...htmlTranslation(translations, 'tk_filters')} />
            </Container>
            <Container pt="6">
              <FiltersTitle />
              <Container pt="4">
                <Filters />
              </Container>
            </Container>
          </Container>
        ) : null}
        <Container width={['full', 'full', '3/4']}>
          <Tabs
            items={tabItems.map((tabItem, index) => ({
              tabName: tabItem.label,
              tabIndex: index
            }))}
            isItemSelected={e => e.tabIndex === selectedTabItemIndex}
            getItemLabel={e => e.tabName}
            onItemSelectedHandler={e => {
              handleClickTab(e.tabIndex)
            }}
            data-testing="ProfileQoins_Tabs">
            <Container fullWidth divider={Container.dividers.top}>
              {!Tools.isDesktop() ? (
                <Container py="4" fullWidth divider={Container.dividers.bottom}>
                  <Container
                    fullWidth
                    display={Container.displays.flex}
                    justifyContent={Container.justifyContentValues.between}
                    alignItems={Container.alignItemsValues.center}>
                    <FiltersTitle />
                    <Container onClickHandler={toggleShowFilters}>
                      <Icon image={Icon.images.menu} />
                    </Container>
                  </Container>
                  {showFilters ? (
                    <Container py="4">
                      <Filters />
                    </Container>
                  ) : null}
                </Container>
              ) : null}
              {selectedTabItemIndex >= 0 && (
                <Container pt={['8', '12']}>
                  <TextBody
                    {...htmlTranslation(translations, 'tk_listDescription')}
                  />
                  <Container pt={['2', '4']}>
                    <TextBody
                      size={TextBody.sizes.s}
                      {...htmlTranslation(translations, 'tk_listDisclaimer')}
                    />
                  </Container>
                  {Object.keys(filteredProductsBySection)
                    .sort((a, b) => {
                      return filteredProductsBySection[b] &&
                        filteredProductsBySection[b].products &&
                        filteredProductsBySection[b].products.length === 0
                        ? -1
                        : 0
                    })
                    .map((section, index) => {
                      return filteredProductsBySection[section] ? (
                        <Container
                          key={index}
                          py="12"
                          divider={index > 0 ? Container.dividers.top : null}>
                          <TextTitle heading={TextTitle.headings.h3}>
                            {filteredProductsBySection[section].title}
                          </TextTitle>
                          {filteredProductsBySection[section].products.length >
                          0 ? (
                            <Container pt="8">
                              <LoyaltyProductList
                                translations={translations}
                                products={
                                  filteredProductsBySection[section].products
                                }
                                alternative={section === sections.exchange}
                                productBaseUrl={bauPath}
                              />
                            </Container>
                          ) : (
                            <Container pt="8">
                              <TextBody
                                {...htmlTranslation(
                                  translations,
                                  'tk_noProducts'
                                )}
                              />
                            </Container>
                          )}
                        </Container>
                      ) : null
                    })}
                </Container>
              )}
            </Container>
          </Tabs>
        </Container>
      </Container>
      <Container
        pt="8"
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.center}>
        <TextBody>
          <Link disabled={loading} href={termsUrl}>
            {translations.tk_terms}
          </Link>
        </TextBody>
      </Container>
    </>
  )
}

const LotteryProductList = props => {
  return (
    <ToastContext>
      <PublishedComponent
        innerComponent={LotteryProductListComponent}
        mainLayout
        {...ComponentDefaultProps}
        {...props}
      />
    </ToastContext>
  )
}

const ComponentTranslations = {
  ...LotteryProductListTranslations,
  ...CommonTranslations
}

const ComponentDefaultProps = {
  componentName: 'LotteryProductList',
  translations: {
    ...parseTranslations(ComponentTranslations, true)
  }
}

LotteryProductList.getInitialProps = async req => {
  return PublishedComponent.getGlobalInitialProps({
    context: req && req.query && req.query.context,
    componentName: ComponentDefaultProps.componentName,
    defaultTranslations: ComponentDefaultProps.translations,
    translationsConfig: ComponentTranslations,
    getSpecificInitialProps: async () => {
      const campaignId =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('campaignId')
          : (req.query && req.query.campaign_id) || ''

      const campaignCode =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('campaignId')
          : (req.query && req.body.extra.campaign_code) || ''

      const filters =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('productFilters')
          : (req.body.extra && req.body.extra.filters) || null
      const termsUrl =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('termsUrl')
          : (req.body.extra && req.body.extra.tandc) || null
      const bauPath =
        req && req.query && req.query.mock === 'true'
          ? getInitialPropsMock('bauPath')
          : (req.body.extra && req.body.extra.bau_path) || null

      let res = null
      let error = null

      try {
        res = campaignId
          ? await api.iqospherePrize.getPrizes(campaignId)
          : await api.iqospherePrize.getPrizesCampaign(campaignCode)
      } catch (err) {
        const message = extractErrorMessage(err)
        // since API GW does not send us a proper 404 we need to treat in a special way this error
        // in order for Drupal to send a proper 404
        if (message === 'Product not available') {
          return {
            error: {
              message,
              status: 404
            }
          }
        } else if (err.data && err.data.data && err.data.data.products) {
          error = {
            message: err.data.message,
            status: err.status
          }
        } else {
          throw err
        }
      }

      const productDataList = res?.prizes
      if (!productDataList) {
        return {
          error: {
            message: 'Product List not available',
            status: 404
          }
        }
      }

      return {
        error,
        productDataList,
        filters,
        termsUrl,
        bauPath,
        reqProps: {
          query: req.query,
          extra: req.body.extra
        }
      }
    }
  })
}

export default LotteryProductList
